<template>
  <div class="selected-group" v-if="selectedGroup">
    <p class="selected-group__name">
      {{
        $t("message.businessAddresses.groups.facilities.selectedGroup", [
          selectedGroup ? selectedGroup.name : ""
        ])
      }}
    </p>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "SelectedFacilitiesGroup",
  computed: {
    ...mapState({
      selectedGroup: state => state.facilitiesGroups.selectedGroup || null
    })
  }
};
</script>

<style lang="scss" scoped>
.selected-group {
  font-weight: 500;
  @include font-size(14px);
  line-height: 17px;
  color: $text-muted;
  display: flex;
  align-items: center;

  &__name {
    margin: 0;
    margin-left: $spacing / 2;
    margin-right: $spacing;
  }
}
</style>
